import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cfd7b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_mobile_banner = _resolveComponent("app-mobile-banner")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_mobile_banner),
    _createVNode(_component_app_header),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_router_view, { "data-test": "app-router" })
    ]),
    _createVNode(_component_app_footer)
  ], 64))
}